import React from 'react';
import EvaluatorAdmin from './EvaluatorAdmin';
import TabbedPage from '../../../Elements/TabbedPage';
import EvaluatorPersonaExportAdmin from './EvaluatorPersonaExportAdmin';
import EvaluatorEmailCampaignExportAdmin from './EvaluatorEmailCampaignExportAdmin';
import EvaluatorTextMessageExportAdmin from './EvaluatorTextMessageExportAdmin';
import EvaluatorSchedulingExportAdmin from './EvaluatorSchedulingExportAdmin';
import EvaluatorLeadAdmin from '../../ThirdParty/EvaluatorLead/EvaluatorLeadAdmin';

export default class EvaluatorParentAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  urlParams = new URLSearchParams(window.location.search);
  tab = this.urlParams.has('tab') ? parseInt(this.urlParams.get('tab')) : 0;

  componentDidMount() {}

  tabs = [
    { label: 'Evaluator', id: 'evaluator', icon: 'fa-solid fa-user', component: <EvaluatorAdmin /> },
    {
      label: 'Email Campaign Export',
      id: 'emailcampaignexport',
      icon: 'fa-solid fa-envelope',
      component: <EvaluatorEmailCampaignExportAdmin />,
      roleKey: 'email_campaign_export_tab',
    },
    {
      label: 'Text Message Export',
      id: 'textmessageexport',
      icon: 'fa-solid fa-messages',
      component: <EvaluatorTextMessageExportAdmin />,
      roleKey: 'text_message_export_tab',
    },
    {
      label: 'Persona Export',
      id: 'evaluatorpersonaexport',
      icon: 'fa-solid fa-person',
      component: <EvaluatorPersonaExportAdmin />,
      roleKey: 'persona_export_tab',
    },
    {
      label: 'Scheduling Report',
      id: 'evaluatorschedulingexport',
      icon: 'fa-solid fa-calendar-days',
      component: <EvaluatorSchedulingExportAdmin />,
      roleKey: 'scheduling_export_tab',
    },
    {
      label: 'Evaluator Leads',
      id: 'evaluatorleads',
      icon: 'fa-solid fa-address-book',
      component: <EvaluatorLeadAdmin />,
    },
  ];

  render() {
    return (
      <div className='contentwrapper'>
        {this.state.window}
        <div className='bg-white p-1'>
          <div className='TabbedPage'>
            <TabbedPage
              tabs={this.tabs}
              openOnTab={this.tab}
              removeSearchParametersOnTabChange={true}
            />
          </div>
        </div>
      </div>
    );
  }
}
